/********* LIST *********/

export const GET_USER_ROLE_LIST = 'GET_USER_ROLE_LIST'
export const GET_USER_ROLE_LIST_OK = 'GET_USER_ROLE_LIST_OK'
export const GET_USER_ROLE_LIST_ERR = 'GET_USER_ROLE_LIST_ERR'
export const DO_USER_ROLE_LIST_CLEANUP = 'DO_USER_ROLE_LIST_CLEANUP'